import {
  Typography,
  Box,
  Chip,
  Divider
} from "@mui/material";
import {
  CalendarToday as CalendarIcon
} from "@mui/icons-material";



export default function ContactUsPage() {

  return (
    <Box sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
      {/* Header */}
      <Typography variant="h3" gutterBottom color="primary">
        Contact Us Page
      </Typography>

      <Typography variant="body1" color="text.secondary" paragraph>
        This is a Contact Us page.
      </Typography>

      <Divider sx={{ my: 3 }} />

    </Box>
  );
}